module.exports = __webpack_public_path__ + "img/zunder_logo.870cbd62.svg";